// extracted by mini-css-extract-plugin
export default {"button":"kr-z","reviewSort":"lr-z"};